export default{
    errorCode: [
        {
            "id": "200",
            "value": "HTTP请求成功"
        },
        {
            "id": "401",
            "value": "授权失败"
        },
        {
            "id": "403",
            "value": "登录状态失效"
        },
        {
            "id": "500",
            "value": "系统异常"
        },
        {
            "id": "1001",
            "value": "HTTP请求失败"
        },
        {
            "id": "1002",
            "value": "权限不足"
        },
        {
            "id": "1501",
            "value": "账号密码不匹配"
        },
        {
            "id": "1502",
            "value": "未找到该账号信息"
        },
        {
            "id": "1503",
            "value": "密码不能为空"
        },
        {
            "id": "2001",
            "value": "修改采购类型失败"
        },
        {
            "id": "2002",
            "value": "修改库存类型设置失败"
        },
        {
            "id": "2003",
            "value": "系统类型错误"
        },
        {
            "id": "2501",
            "value": "账号已存在"
        },
        {
            "id": "2502",
            "value": "权限不能为空"
        },
        {
            "id": "2503",
            "value": "添加账号失败"
        },
        {
            "id": "2504",
            "value": "删除账号失败"
        },
        {
            "id": "2505",
            "value": "不存在该账号"
        },
        {
            "id": "2506",
            "value": "修改账号失败"
        },
        {
            "id": "3001",
            "value": "无效的客户编号"
        },
        {
            "id": "3002",
            "value": "信息内容已变更"
        },
        {
            "id": "3003",
            "value": "资料信息编辑失败"
        },
        {
            "id": "3501",
            "value": "不存在物资采购订单"
        },
        {
            "id": "3502",
            "value": "保存物资采购订单失败"
        },
        {
            "id": "3503",
            "value": "删除物资采购订单失败"
        },
        {
            "id": "3504",
            "value": "不存在服务采购订单"
        },
        {
            "id": "3505",
            "value": "保存服务采购订单失败"
        },
        {
            "id": "3506",
            "value": "删除服务采购订单失败"
        },
        {
            "id": "3604",
            "value": "不存在外协采购订单"
        },
        {
            "id": "3605",
            "value": "保存外协采购订单失败"
        },
        {
            "id": "3606",
            "value": "删除外协采购订单失败"
        },
        {
            "id": "3607",
            "value": "物资采购类型修改失败"
        },
        {
            "id": "3608",
            "value": "不存在物资采购类型"
        },
        {
            "id": "3609",
            "value": "删除物资采购类型失败"
        },
        {
            "id": "3610",
            "value": "删除物资采购商品名称失败"
        },
        {
            "id": "3611",
            "value": "修改物资采购商品名称失败"
        },
        {
            "id": "3612",
            "value": "删除物资采购商品规格失败"
        },
        {
            "id": "3613",
            "value": "修改物资采购商品规格失败"
        },
        {
            "id": "3614",
            "value": "删除物资采购商品型号失败"
        },
        {
            "id": "3615",
            "value": "修改物资采购商品型号失败"
        },
        {
            "id": "3616",
            "value": "删除物资采购商品价格失败"
        },
        {
            "id": "3617",
            "value": "修改物资采购商品价格失败"
        },
        {
            "id": "3618",
            "value": "不存在外协采购类型"
        },
        {
            "id": "3619",
            "value": "删除外协采购类型失败"
        },
        {
            "id": "3620",
            "value": "不存在该外协供应商"
        },
        {
            "id": "3621",
            "value": "不存在服务采购类型"
        },
        {
            "id": "3622",
            "value": "删除服务采购类型失败"
        },
        {
            "id": "3623",
            "value": "修改服务采购类型失败"
        },
        {
            "id": "3624",
            "value": "修改服务采购内容失败"
        },
        {
            "id": "3625",
            "value": "删除服务采购内容失败"
        },
        {
            "id": "3626",
            "value": "修改服务采购规格失败"
        },
        {
            "id": "3627",
            "value": "删除服务采购规格失败"
        },
        {
            "id": "3628",
            "value": "修改服务采购价格失败"
        },
        {
            "id": "3629",
            "value": "删除服务采购价格失败"
        },
        {
            "id": "3630",
            "value": "该物资类型下已存在相同的商品名称"
        },
        {
            "id": "3631",
            "value": "该物资类型下已存在相同的商品规格"
        },
        {
            "id": "3632",
            "value": "该物资类型下已存在相同的商品型号"
        },
        {
            "id": "3633",
            "value": "该物资类型下已存在相同的采购单价"
        },
        {
            "id": "3634",
            "value": "不存在该物资商品名称"
        },
        {
            "id": "3635",
            "value": "不存在该物资商品规格"
        },
        {
            "id": "3636",
            "value": "不存在该物资商品型号"
        },
        {
            "id": "3637",
            "value": "不存在该物资商品价格"
        },
        {
            "id": "3638",
            "value": "已存在相同的服务采购类型"
        },
        {
            "id": "3639",
            "value": "已存在相同的服务采购类型"
        },
        {
            "id": "3640",
            "value": "已存在相同的服务采购规格"
        },
        {
            "id": "3641",
            "value": "已存在相同的服务采购价格"
        },
        {
            "id": "3642",
            "value": "服务采购内容不存在"
        },
        {
            "id": "3643",
            "value": "服务采购商品规格不存在"
        },
        {
            "id": "3644",
            "value": "服务采购单价不存在"
        },
        {
            "id": "3645",
            "value": "不存在服务采购供应商"
        },
        {
            "id": "3646",
            "value": "服务采购供应商已存在"
        },
        {
            "id": "4001",
            "value": "不存在该库存物资"
        },
        {
            "id": "4002",
            "value": "修改库存清单失败"
        },
        {
            "id": "4003",
            "value": "删除库存清单出入库记录失败"
        },
        {
            "id": "4004",
            "value": "盘点库存失败"
        },
        {
            "id": "4005",
            "value": "不存在库存入库记录"
        },
        {
            "id": "4006",
            "value": "入库类型错误"
        },
        {
            "id": "4007",
            "value": "采购单号或核价单号不存在"
        },
        {
            "id": "4008",
            "value": "保存入库记录失败"
        },
        {
            "id": "4009",
            "value": "删除入库记录失败"
        },
        {
            "id": "4010",
            "value": "不存在库存出库记录"
        },
        {
            "id": "4011",
            "value": "出库类型错误"
        },
        {
            "id": "4012",
            "value": "出库物资类型错误"
        },
        {
            "id": "4013",
            "value": "出库采购单号/生产单号错误"
        },
        {
            "id": "4014",
            "value": "出库领料单错误"
        },
        {
            "id": "4015",
            "value": "出库库存不足"
        },
        {
            "id": "4016",
            "value": "保存出库记录失败"
        },
        {
            "id": "4018",
            "value": "删除出库记录失败"
        },
        {
            "id": "4019",
            "value": "出库领料单错误"
        },
        {
            "id": "4501",
            "value": "未找到相关生产工单"
        },
        {
            "id": "4502",
            "value": "未找到相关领料工单"
        },
        {
            "id": "4503",
            "value": "无效的生产工单或信息已变更"
        },
        {
            "id": "4504",
            "value": "无效的切纸数量"
        },
        {
            "id": "4505",
            "value": "排单日期已存在"
        },
        {
            "id": "4506",
            "value": "存在相同的印刷任务"
        },
        {
            "id": "4507",
            "value": "排单信息不完整"
        },
        {
            "id": "4508",
            "value": "信息已发生变更"
        },
        {
            "id": "4509",
            "value": "无效的排单任务"
        },
        {
            "id": "4510",
            "value": "外协信息不完整"
        },
        {
            "id": "4511",
            "value": "无效的外协任务"
        },
        {
            "id": "4512",
            "value": "存在已发往外协的任务"
        },
        {
            "id": "4599",
            "value": "操作失败"
        },
        {
            "id": "5001",
            "value": "核价单创建失败"
        },
        {
            "id": "5002",
            "value": "核价单信息不完整"
        },
        {
            "id": "5003",
            "value": "无效的订单或信息已变更"
        },
        {
            "id": "5004",
            "value": "核价单编辑失败"
        },
        {
            "id": "5501",
            "value": "不存在物流记录"
        },
        {
            "id": "5502",
            "value": "不存在生产工单号"
        },
        {
            "id": "5503",
            "value": "该物流订单已完成"
        },
        {
            "id": "5504",
            "value": "物流配送单保存失败"
        },
        {
            "id": "5505",
            "value": "物流配送单删除失败"
        },
        {
            "id": "6001",
            "value": "不存在该对账单"
        },
        {
            "id": "6002",
            "value": "对账单删除失败"
        },
        {
            "id": "6003",
            "value": "不存在该客户"
        },
        {
            "id": "6004",
            "value": "保存客户对账单失败"
        },
        {
            "id": "6005",
            "value": "不存在该供应商对账单"
        },
        {
            "id": "6006",
            "value": "不存在该供应商"
        },
        {
            "id": "6007",
            "value": "保存供应商对账单失败"
        },
        {
            "id": "6008",
            "value": "删除供应商对账单失败"
        },
        {
            "id": "6009",
            "value": "不存在该对账单详情"
        },
        {
            "id": "6010",
            "value": "不存在该销售核价单"
        },
        {
            "id": "6011",
            "value": "实收部分失败"
        },
        {
            "id": "6012",
            "value": "实收全部失败"
        },
        {
            "id": "6013",
            "value": "不存在该物资采购订单"
        },
        {
            "id": "6014",
            "value": "不存在该服务采购订单"
        },
        {
            "id": "6015",
            "value": "不存在该外协采购订单"
        },
        {
            "id": "6016",
            "value": "支付部分失败"
        },
        {
            "id": "6017",
            "value": "支付全部失败"
        }
    ]
}





// WEBPACK FOOTER //
// ./src/errorCode.js